import React, { type FC, type PropsWithChildren } from 'react';

import { type Scalars } from '../../../../__generated-gql-types__/globalTypes';

import {
  BaseScheduleModalLayout,
  type BaseScheduleModalLayoutProps,
  type BaseScheduleModalLayoutPropsInner,
} from './BaseScheduleModalLayout';

export interface BaseScheduleSubmissionModalLayoutProps
  extends BaseScheduleModalLayoutProps {
  onBackClick: () => void;
  scheduledSessionId?: Scalars['CoachingSessionUrn']['output'];
}
type BaseScheduleSubmissionModalLayoutPropsInner =
  BaseScheduleSubmissionModalLayoutProps & BaseScheduleModalLayoutPropsInner;

export const BaseScheduleSubmissionModalLayout: FC<
  PropsWithChildren<BaseScheduleSubmissionModalLayoutPropsInner>
> = ({ children, onBackClick, coach, scheduledSessionId, ...baseProps }) => {
  return (
    <BaseScheduleModalLayout
      coach={coach}
      scheduledSessionId={scheduledSessionId}
      onBackClick={onBackClick}
      {...baseProps}
    >
      <div className="flex w-full flex-col items-center justify-center overflow-hidden">
        <div className="flex w-full grow justify-center overflow-auto">
          {children}
        </div>
      </div>
    </BaseScheduleModalLayout>
  );
};
